import {RetailerDetails} from '@/pages/(shared)/retailers/detail/components/retailerDetails';
import {RetailerDetailsProvider} from '@/pages/(shared)/retailers/detail/providers/retailerDetailsProvider';

export function RetailerDetailsPage() {
  return (
    <RetailerDetailsProvider>
      <RetailerDetails />
    </RetailerDetailsProvider>
  );
}
